<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Ciudades</h3>
              </div>
              <div class="col-6 text-right">
                <base-button class="hover-apolo" type="default" icon size="sm" @click="showAddModal = true">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Ciudad</span>
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
            <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Datos por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item.value"
                  :label="item.descripcion"
                  :value="Number(item.value)"
                >
                </el-option>
            </el-select>
  
              <div>
                <form class="apolo-borde">
                  <base-input
                    v-model="query"
                    type="search"
                    append-icon="fas fa-search"
                    placeholder="Buscar..."
                    clearable
                    inputClasses="apolo-borde"
                  />
                </form>
              </div>
            </div>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="ciudades"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="ciudades">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Nombre" prop="nombre" />
              <el-table-column label="Abreviatura" prop="abreviatura" />
              <el-table-column align="center">
                <div slot-scope="{ row }" class="table-actions">
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="editCity(row)">
                    <span class="btn-inner--text">Editar</span>
                  </base-button>
                  <base-button class="hover-apolo" type="primary" icon size="sm" @click="deleteCity(row.id)">
                    <span class="btn-inner--text">Eliminar</span>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
           <!--<div class="">
              <p class="card-category">
                Mostrando {{ total ? from + 1 : 0 }} a {{ to }} de
                {{ total }} entradas
  
                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} filas seleccionadas
                </span>
              </p>
            </div>
            --> 
            <base-pagination
              class="pagination-no-border justify-content-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
      <!-- MODAL CREATE -->
      <modal :show.sync="showAddModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Crear ciudad</h6>
        <form class="new-event--form" @submit.prevent="addCity">
          <base-input label="Nombre"
                      placeholder="Nombre de la ciudad"
                      v-model="ciudad.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Abreviatura"
                      placeholder="Abreviatura de la ciudad"
                      v-model="ciudad.abreviatura"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.abreviatura" />
          <base-input label="Seleccione un timezone">
            <multiselect v-model="ciudad.timezone" :options="timezones" placeholder="Selecccione un timezone" label="nombre" track-by="nombre" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.timezone" />

          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="addCity">Guardar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL EDIT -->
      <modal :show.sync="showEditModal" modal-classes="modal-primary">
        <h6 slot="header" class="mb-0 modal-title">Editar ciudad</h6>
        <form class="new-event--form" @submit.prevent="editCity">
          <base-input label="Nombre"
                      placeholder="Nombre de la ciudad"
                      v-model="ciudad.nombre"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.nombre" />
          <base-input label="Abreviatura"
                      placeholder="Abreviatura de la ciudad"
                      v-model="ciudad.abreviatura"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.abreviatura" />
          <base-input label="Seleccione un timezone">
            <multiselect v-model="ciudad.timezone" :options="timezones" placeholder="Selecccione un timezone" label="nombre" track-by="nombre" :showLabels="false"></multiselect>
          </base-input>
          <validation-error :errors="apiValidationErrors.timezone" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>

        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="updateCity">Actualizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="closeModal">Cerrar</button>
        </template>
      </modal>
    </div>
  </template>
  <script>
  import Multiselect from 'vue-multiselect';
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ValidationError from "@/components/ValidationError.vue";
  import formMixin from "@/mixins/form-mixin";
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      Multiselect,
      ValidationError,
      Modal,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        ciudades: [],
        timezones: [],
        selectedRows: [],
        query: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 ciudades por página'},
          {value:'10', descripcion: '10 ciudades por página'},
          {value:'25', descripcion: '25 ciudades por página'},
          {value:'50', descripcion: '50 ciudades por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        ciudad: {
          type: "ciudades",
          nombre: null,
          abreviatura: null,
          timezone: null
        }
      };
    },

    created(){
      this.getTimezones();
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      query: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },
  
    methods: {
      async getTimezones(){
        let params = {
          filter: {
          },
          page: {
            number: 1,
            size: 100000,
          },
        };
        await this.$store.dispatch("ciudades/listTimezone", params).then(() => {
          this.timezones = this.$store.getters["ciudades/listTimezone"];
        });
      },

      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),
  
      async getList() {
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { nombre: this.query } : {}),
            ...(this.query ? { abreviatura: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
  
        await this.$store.dispatch("ciudades/list", params).then(() => {
          this.ciudades = this.$store.getters["ciudades/list"];
          this.total = this.$store.getters["ciudades/listTotal"];
        });
        this.loading = false;
      },

      closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.ciudad.nombre = null;
        this.ciudad.abreviatura = null;
        this.ciudad.timezone = null;
      },

      async addCity(){
        try {
        await this.$store.dispatch("ciudades/add", this.ciudad);

        this.$notify({
          type: "success",
          message: "Ciudad creada satisfactoriamente.",
          duration: -1
        });
        this.getList();
        this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      editCity(row) {
        console.log(this.timezones)
        this.resetApiValidation();
        this.showEditModal = true;
        this.ciudad.nombre = row.nombre;
        this.ciudad.abreviatura = row.abreviatura;
        this.ciudad.timezone = this.timezones.find(item => item.timezone == row.timezone);
        console.log(this.ciudad.timezone)
        this.ciudad.id = row.id;
      },

      async updateCity() {
        try{
          await this.$store.dispatch("ciudades/update", this.ciudad);
          this.$notify({
            type: "success",
            message: "Ciudad actualizada satisfactoriamente.",
            duration: -1
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
  
      async deleteCity(id) {
        const confirmation = await swal.fire({
          title: `¿Desea eliminar esta ciudad?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
            await this.$store.dispatch("ciudades/destroy", id);
            await this.getList();
            this.$notify({
              type: "success",
              message: "Ciudad eliminada satisfactoriamente.",
              duration: -1
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: "Esta ciudad esta asociada al menos a una terminal.",
              duration: -1
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
              duration: -1
            });
          }
        }
      },
      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"/>
  <style>
    .multiselect__option--highlight {
      background: #0068a0;
      outline: none;
      color: white;
    }
    .multiselect__option--highlight:after {
      content: attr(data-select);
      background: #0068a0;
      color: white;
    }
  </style>